import { cartTypes } from "../actions/types"

const storedItems = localStorage.getItem('cartItems')

const initialState = {
  webOrderId: null,
  items: storedItems ? JSON.parse(storedItems) : [],
}

export const cartReducer =
  (
    state = initialState,
    action
  ) => {
    switch (action.type) {
      case cartTypes.ADD_ITEM:
        return {
          ...state,
          items: [...state.items, action.payload],
        }
      case cartTypes.EDIT_ITEM:
        return {
          ...state,
          items: state.items.map((item, index) =>
            index === action.payload.index ? action.payload.item : item
          ),
        }
      case cartTypes.REMOVE_ITEM:
        return {
          ...state,
          items: state.items.filter(item => item.productId !== action.payload),
        }
      case cartTypes.SET_ORDER_ID:
        return {
          ...state,
          webOrderId: action.payload,
        }
      case cartTypes.SET_INTEGRATION_ID:
        return {
          ...state,
          integrationId: action.payload,
        }
      case cartTypes.CLEAR:
        return {
          webOrderId: null,
          items: [],
        }
      default:
        return state
    }
  }